import React, { FC, useMemo } from 'react';
import { MenuItem } from '@mui/material';
import { ControlledNumberInput, ControlledSelect, CreditFrequency, ISupportType } from '../../../shared';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
    path: string;
    supportTypes: ISupportType[];
}

export const SupportTypesInfoInputs: FC<Props> = ({ path, supportTypes }) => {
    const { t } = useTranslation();

    const form = useFormContext();
    const watchSupportTypeInfo = form.watch(`${path}.supportTypeId`);

    const hasCredit = useMemo(() => {
        return watchSupportTypeInfo && supportTypes?.find((type) => type.id === watchSupportTypeInfo)?.hasCredit;
    }, [watchSupportTypeInfo, supportTypes]);

    const type = (
        <ControlledSelect name={`${path}.supportTypeId`} label={t('nameLabel')} required key="type">
            {supportTypes?.map((item: ISupportType) => (
                <MenuItem value={item.id} key={item.id}>
                    {item.name}
                </MenuItem>
            ))}
        </ControlledSelect>
    );

    if (!hasCredit) return type;
    return [
        type,
        <ControlledNumberInput name={`${path}.credit`} label={t('creditLabel')} key="credit" />,
        <ControlledSelect name={`${path}.frequency`} defaultValue={''} label={t('frequencyLabel')} key="frequency">
            <MenuItem key={''} value={''} sx={{ height: '35px' }} />
            {Object.values(CreditFrequency)?.map((item) => (
                <MenuItem value={item} key={item}>
                    {t(item)}
                </MenuItem>
            ))}
        </ControlledSelect>,
    ];
};
